import { Static, Type } from '@sinclair/typebox';
import { MinimalUser, minimalUserSchema } from '../../shared/user/user.schema';

export const userRelationSchema = Type.Object({
  id: Type.String({
    description: 'Unique identifier of the user relation for the provider. Usually an internal identifier used by the API only.',
  }),
  object: Type.Literal('UserRelation'),
  user: Type.Object(minimalUserSchema, { description: 'The user of the relation.' }),
  created_at: Type.Optional(Type.String({ description: 'Date and time when the relation was created. ' })),
});

export type UserRelation<UserSpecifics = unknown> = Omit<Static<typeof userRelationSchema>, 'user'> & {
  user: MinimalUser<UserSpecifics>;
};
